<script setup>
import { tl } from '../i18n'
import { showNewVersionAvailable } from './new-version-available-state'

const l = tl('newVersionAvailable')

const refresh = () => {
  window.location.reload()
}
</script>

<template>
  <div
    v-if="showNewVersionAvailable"
    class="card text-bg-dark new-version-panel"
  >
    <div class="card-body">
      <p>{{ l('text') }}</p>
      <div class="d-grid">
        <button
          class="btn btn-light"
          @click="refresh"
        >
          {{ l('button') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.new-version-panel {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999999;
}
</style>
